import { Table, TableProps, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, createSearchParams } from 'react-router-dom';

import { InterviewScriptTemplateCollection, SerialID, StageSubTypeChoices } from '../../../types';
import { getFrontendManualTranslations } from '../../../utils';

interface InterviewScriptTemplateFormat {
  id: SerialID;
  name: string;
  type: InterviewScriptTemplateCollection['type'];
}

interface InterviewScriptTemplateTableProps extends TableProps<InterviewScriptTemplateFormat> {
  searchParams?: URLSearchParams;
  enableChangeLanguage?: boolean;
}

const InterviewScriptTemplateTable = ({
  pagination,
  searchParams,
  enableChangeLanguage = false,
  ...props
}: InterviewScriptTemplateTableProps) => {
  const { t } = useTranslation();

  return (
    <Table<InterviewScriptTemplateFormat>
      rowKey="id"
      pagination={{
        showTotal: (total) => {
          return t('Total: {{total}} roteiros', { total });
        },
        ...pagination,
      }}
      {...props}
    >
      <Table.Column
        width="50%"
        key="name"
        title={t('Nome do roteiro')}
        dataIndex="name"
        render={(_, record: InterviewScriptTemplateFormat) => (
          <Link
            key={`link-${record.id}`}
            className="ant-typography-link"
            to={{
              pathname: `${record.id}/change`,
              search: createSearchParams(searchParams).toString(),
            }}
          >
            {record.name}
          </Link>
        )}
      />
      <Table.Column
        width="50%"
        key="type"
        title={t('Tipo de entrevista')}
        dataIndex="type"
        render={(_, record: InterviewScriptTemplateFormat) =>
          record.type.map((type) => (
            <Tag key={`${record.id}-${type}`}>
              {getFrontendManualTranslations(StageSubTypeChoices[type], enableChangeLanguage)}
            </Tag>
          ))
        }
      />
    </Table>
  );
};

export default InterviewScriptTemplateTable;
